import { AccrualLineField } from "@common/helpers/accrualLineDeltas";

const ACCRUAL_LINE_FIELD_LABELS: Record<AccrualLineField, string> = {
    description: "description",
    amount: "amount",
    unitAmount: "unit amount",
    quantityDecimal: "quantity",
    currency: "currency",
    accountId: "accrual ledger",
    accountsPayableId: "payables account",
    accountsReceivableId: "receivables account",
    classIds: "classes",
};

const ACCRUAL_LINE_FIELD_LABEL_LOOKUP: Record<string, string> =
    ACCRUAL_LINE_FIELD_LABELS;

export function getAccrualLineFieldLabel(field: string): string {
    return ACCRUAL_LINE_FIELD_LABEL_LOOKUP[field] ?? field;
}
